/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMobileDeviceOrdered
 */
export interface ReadOnlyMobileDeviceOrdered {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMobileDeviceOrdered
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMobileDeviceOrdered
     */
    type?: ReadOnlyMobileDeviceOrderedTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMobileDeviceOrdered
     */
    imei: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMobileDeviceOrdered
     */
    simIccid: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMobileDeviceOrdered
     */
    externalId: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMobileDeviceOrdered
     */
    client?: number;
}

export function ReadOnlyMobileDeviceOrderedFromJSON(json: any): ReadOnlyMobileDeviceOrdered {
    return ReadOnlyMobileDeviceOrderedFromJSONTyped(json, false);
}

export function ReadOnlyMobileDeviceOrderedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMobileDeviceOrdered {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'imei': json['imei'],
        'simIccid': json['simIccid'],
        'externalId': json['external_id'],
        'client': !exists(json, 'client') ? undefined : json['client'],
    };
}

export function ReadOnlyMobileDeviceOrderedToJSON(value?: ReadOnlyMobileDeviceOrdered | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'imei': value.imei,
        'simIccid': value.simIccid,
        'external_id': value.externalId,
        'client': value.client,
    };
}

/**
* @export
* @enum {string}
*/
export enum ReadOnlyMobileDeviceOrderedTypeEnum {
    _1 = '1'
}


